module.exports = __webpack_public_path__ + "assets/img/202109-5W.5ca5ec54.png";